export const WORKSPACE_VIEW_CARD = "card";
export const WORKSPACE_VIEW_TABLE = "table";
